import type { PropsWithChildren } from 'react';

import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

import { Hint } from '@vestigas/ui';

type P = PropsWithChildren<{
  /** The nesting level (1 = root level) */
  level?: number;
}> &
  ComponentStyling;

/**
 * Placeholder component for empty tree sections at level 1.
 * Shows a hint text for sections without children.
 */
export function TreeItemEmpty({ className, level = 1, style }: P) {
  const { t } = useTranslation('contract');

  if (level !== 1) {
    return null;
  }

  return (
    <li className={cn('text-sm font-normal', className)} style={style}>
      <Hint>{t(($) => $.form.treeViewer.noChildrenHint)}</Hint>
    </li>
  );
}
